import { z } from "zod";

import {
	SnackBlockItemContainerInputSchema,
	SnackBlockItemInputSchema,
	SnackBlocksInputSchema,
	SnackSnsIconInputSchema,
	SnackSnsIconsSettingInputSchema,
} from "@/lib/zod/__generated__/validation-schema";

export const snackBlocksInputZodSchema = SnackBlocksInputSchema.extend({
	companyID: z.string(),
	snsSetting: z.lazy(() =>
		SnackSnsIconsSettingInputSchema.extend({
			snsIcons: z.array(
				z.lazy(() =>
					SnackSnsIconInputSchema.extend({
						selected: z.boolean(),
						url: z.string().nullish(),
					}).refine(
						({ selected, url }) => {
							if (!selected) {
								// 選択されていない場合はURLの入力が不要
								return true;
							}

							// 選択されている場合はURLの入力が必須
							/**
							 * 有効なURLかどうかの判定ロジックは zodの `string().url()` を参考にした
							 * @see https://github.com/colinhacks/zod/blob/e30870369d5b8f31ff4d0130d4439fd997deb523/src/types.ts#L919-L931
							 */
							try {
								if (!url) throw new Error();

								new URL(url);

								return true;
							} catch (error) {
								return false;
							}
						},
						{ message: "SNSのURLを入力してください", path: ["url"] },
					),
				),
			),
		}),
	),
	blocks: z.array(
		z.discriminatedUnion("layoutType", [
			SnackBlockItemContainerInputSchema.extend({
				title: z.string().min(1).max(50).or(z.literal("")),
				layoutType: z.literal("column-1"),
				items: z
					.array(
						z
							.lazy(() =>
								SnackBlockItemInputSchema.extend({
									title: z.string(),
									thumbnail: z.string(),
								}),
							)
							.or(
								z.object({
									isEmpty: z.literal(true),
								}),
							),
					)
					.min(1)
					.max(1),
			}),

			SnackBlockItemContainerInputSchema.extend({
				title: z.string().min(1).max(50).or(z.literal("")),
				layoutType: z.literal("column-2"),
				items: z
					.array(
						z.lazy(() =>
							SnackBlockItemInputSchema.extend({
								title: z.string(),
								thumbnail: z.string(),
							}).or(
								z.object({
									isEmpty: z.literal(true),
								}),
							),
						),
					)
					.min(2)
					.max(2),
			}),

			SnackBlockItemContainerInputSchema.extend({
				title: z.string().min(1).max(50).or(z.literal("")),
				layoutType: z.literal("column-3"),
				items: z
					.array(
						z.lazy(() =>
							SnackBlockItemInputSchema.extend({
								title: z.string(),
								thumbnail: z.string(),
							}).or(
								z.object({
									isEmpty: z.literal(true),
								}),
							),
						),
					)
					.min(3)
					.max(3),
			}),
		]),
	),
});

const layoutTypeArray = ["column-1", "column-2", "column-3"] as const;
export type SnackBlocksLayoutEnumType = (typeof layoutTypeArray)[number];
export type SnackBlocksZodSchemaType = z.infer<typeof snackBlocksInputZodSchema>;
